import { css } from "@emotion/react";

export const BalanceStyle = {
  index: (open: boolean, color: string, language: string) => css`
    .icon_inforMoney {
      color: ${color};
      cursor: pointer;
      position: relative;
      /* padding-right: 15px; */
      padding-left: 13px;
      display: inline-flex;
      align-items: center;
      gap: 4px;

      &::before {
        content: "$";
        position: absolute;
        left: 0;
        top: 0px;
        width: 10px;
        text-align: right;
      }

      .btn-refresh {
        background: transparent;
        border: none;
        outline: none;
        cursor: pointer;
        padding: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: ${color};

        svg {
          width: 12px;
          height: 12px;
          fill: currentColor;
          transition: transform 0.3s;
          &.spinning {
            animation: spin 1s linear infinite;
          }
        }
      }

      /* &::after {
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        background: url(${`/common/mobile/header/icon_arrowGray.svg`})
          no-repeat center;
        background-size: 100% auto;
        width: 10px;
        height: 10px;
        transform: rotate(${open ? "180deg" : "0deg"});
      } */
    }

    @keyframes spin {
      100% {
        transform: rotate(360deg);
      }
    }
  `,
};
